import { useTheme } from '@mui/material';
import React from 'react';
import './pulse-marker.css';

export interface PulseMarkerProps {
  color?: string;
}

export const PulseMarker: React.FC<PulseMarkerProps> = ({ color }) => {
  const theme = useTheme();
  const markerColor = color || theme.palette.primary.main;

  return (
    <div
      className="pulse-marker"
      role="img"
      aria-label="Pulsing map marker"
    >
      <div
        className="pulse-marker-ring"
        style={{ backgroundColor: markerColor }}
        aria-hidden="true"
      />
      <div
        className="pulse-marker-dot"
        style={{ backgroundColor: markerColor }}
        aria-hidden="true"
      />
    </div>
  );
};
